exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-document-form-modal .document-form-modal__body{padding-top:2rem}", ""]);

// exports
